import React from 'react'
import ReactDOM from 'react-dom'
import get from 'lodash/get'

import { Legend } from '../components/Legend'

export const renderLegend = (chartCtx, legendContainer, cursorDatapoints) => {
  // The metaset is the processed version of the datasets constructed for the chart.
  // The metaset will include the parsed version of the datasets
  //
  // Chart.js deletes the meta of a replaced dataset, leaving a hole until the
  // next update rebuilds it, so a refetched forecast arrives sparse.
  const metasets = get(chartCtx, '_metasets', []).filter(Boolean)
  ReactDOM.render(
    <Legend
      onHide={onHide(chartCtx)}
      metasets={metasets}
      cursorDatapoints={cursorDatapoints}
      chartCtx={chartCtx}
    />,
    legendContainer
  )
}

const onHide = (chartCtx) => (visible, datasetIndex) => {
  if (!visible) {
    chartCtx.hide(datasetIndex)
  } else {
    chartCtx.show(datasetIndex)
  }
}
